<div class="auth-container forgot-password-container">
  <div>
    <h1 class="primary-font-semibold heading">
      {{ 'authentication.reset_your_password' | translate }}
    </h1>
    <p class="primary-font-medium form-description">
      {{ 'authentication.reset_password_details' | translate }}
    </p>
  </div>

  @if (forgotPasswordForm.hasError('serverValidation')) {
    <div class="error-message-container">
      <p class="error-message primary-font-medium form-description">
         {{ serverValidationMessage() }}
      </p>
    </div>
  }

  <form
    [formGroup]="forgotPasswordForm"
    class="form-container"
    (ngSubmit)="submitForgotPassword().subscribe()"
    autocomplete="off"
    [appMarkFormTouched]="forgotPasswordForm"
  >
    <app-error-messages
      [control]="forgotPasswordForm.controls.email"
      [errorKeyMapping]="fieldValidationRules.email"
    >
      <div class="form-group">
        <label class="primary-font-medium form-label" for="email">{{
          'authentication.email' | translate
        }}</label>
        <input
          type="email"
          id="email"
          formControlName="email"
          class="form-input primary-font-medium"
          appErrorStateHighlight
          [errorStateControl]="forgotPasswordForm.controls.email"
          errorStateClass="error-input"
          [class.error-input]="
            (forgotPasswordForm.get('email')?.dirty || forgotPasswordForm.get('email')?.touched) &&
            forgotPasswordForm.get('email')?.invalid
          "
          [placeholder]="'authentication.enter_your_email' | translate"
        />
      </div>
    </app-error-messages>

    <div class="button-container">
      <button
        type="submit"
        class="auth-button primary-button custom-button rounded-pill primary-font-medium"
        [disabled]="forgotPasswordForm.value.email === ''"
      >
        @if (!isSubmitting()) {
          {{ 'authentication.request_verification_code_button' | translate }}
        } @else {
          <output class="spinner-border spinner-border-sm" aria-hidden="true"></output>
        }
      </button>
      <button
        type="button"
        class="auth-button secondary-button custom-button rounded-pill primary-font-medium"
        (click)="goToSignIn.emit()"
      >
        {{ 'authentication.go_back_button' | translate }}
      </button>
    </div>
  </form>
</div>
